export const Hours = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
export const WeekData = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const DegreeType = [ 
    {id: 1, name: "EdD"},
    {id: 2, name: "Enrolled"},
    {id: 3, name: "J.D"},
    {id: 4, name: "Masters"},
    {id: 5, name: "Graduate Coursework"},
    {id: 6, name: "MBA"},
    {id: 7, name: "MD"},
    {id: 8, name: "MEd"},
    {id: 9, name: "Phd"},
    {id: 10, name: "Other"},
]

export const Months = [
    {id: '01', name: 'January'}, 
    {id: '02', name:'February'}, 
    {id: '03', name:'March'}, 
    {id: '04', name:'April'}, 
    {id: '05', name:'May'}, 
    {id: '06', name:'June'}, 
    {id: '07', name:'July'}, 
    {id: '08', name:'August'},
    {id: '09', name:'September'},
    {id: '10', name:'October'},
    {id: '11', name: 'November'},
    {id: '12', name:'December'}
];
export const Days = [
    {id: 1, name: '01'},    
    {id: 2, name: '02'},    
    {id: 3, name: '03'},    
    {id: 4, name: '04'},    
    {id: 5, name: '05'},    
    {id: 6, name: '06'},    
    {id: 7, name: '07'},    
    {id: 8, name: '08'},    
    {id: 9, name: '09'},    
    {id: 10, name: '10'},    
    {id: 11, name: '11'},    
    {id: 12, name: '12'},    
    {id: 13, name: '13'},    
    {id: 14, name: '14'},    
    {id: 15, name: '15'},    
    {id: 16, name: '16'},    
    {id: 17, name: '17'},    
    {id: 18, name: '18'},    
    {id: 19, name: '19'},    
    {id: 20, name: '20'},    
    {id: 21, name: '21'},    
    {id: 22, name: '22'},    
    {id: 23, name: '23'},    
    {id: 24, name: '24'},    
    {id: 25, name: '25'},    
    {id: 26, name: '26'},    
    {id: 27, name: '27'},    
    {id: 28, name: '28'},    
    {id: 29, name: '29'},    
    {id: 30, name: '30'},    
    {id: 31, name: '31'},    
];